<template>
  <v-container>
    <PaidWarrantsProcessedDetails
      :program="program"
      :chunkID="chunkID"
      v-if="profileType === 'importedPaidWarrants'"
    />
  </v-container>
</template>

<script>
import PaidWarrantsProcessedDetails from '@/components/bulk/PaidWarrantsProcessedDetails.vue';

export default {
  name: 'ViewFileProcessedDetails',
  created() {
    this.profileType = this.$route.params.type;
    this.fetchProgram();
  },
  data: () => ({
    profileType: '',
    program: '',
    chunkID: '',
  }),
  components: {
    PaidWarrantsProcessedDetails,
  },
  methods: {
    fetchProgram() {
      const query = (this.$route || {}).query || {};
      this.program = query.program;
      this.chunkID = String(query.chunkID || '');
    },
  },
};
</script>
